import { render, staticRenderFns } from "./EnroachmentRowResolution.vue?vue&type=template&id=70b780f2"
import script from "./EnroachmentRowResolution.vue?vue&type=script&lang=js"
export * from "./EnroachmentRowResolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports